import React, { FC } from 'react';
import {
  ToggleButtonProps as MuiToggleButtonProps,
  ToggleButtonGroupProps as MuiToggleButtonGroupProps,
} from '@mui/material';
import { StyledToggleButton, StyledToggleButtonGroup } from './styled';
export type IToggleButtonProps = MuiToggleButtonProps;
// export type IToggleButtonGroupProps = MuiToggleButtonGroupProps;

import { ToggleButtonGroupProps } from '..';

export const ToggleButtonGroup: FC<ToggleButtonGroupProps> = (props) => {
  return <StyledToggleButtonGroup {...props} />;
};
export const ToggleButton: FC<IToggleButtonProps> = (props) => {
  return <StyledToggleButton {...props} />;
};
